import { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";

import { ErrorPageType } from "@/enum";

import NotFoundImg from "../../assets/images/error-pages/error-404.svg?url";
import UnauthorizeImg from "../../assets/images/error-pages/error-401.svg?url";
import ServerErrorImg from "../../assets/images/error-pages/error-500.svg?url";
import { Button } from "../Button/Button";

interface ErrorPageProps {
	type: ErrorPageType;
}

export const ErrorPage: FunctionComponent<ErrorPageProps> = ({ type }) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`errorPages.${key}`);
	const navigate = useNavigate();

	let title = "";
	let imageSrc = "";

	switch (type) {
		case ErrorPageType.NotFound:
			title = ts("notFound");
			imageSrc = NotFoundImg;
			break;
		case ErrorPageType.Unauthorize:
			title = ts("unauthorize");
			imageSrc = UnauthorizeImg;
			break;
		case ErrorPageType.ServerError:
			title = ts("serverError");
			imageSrc = ServerErrorImg;
			break;
		case ErrorPageType.Forbidden:
			title = ts("forbidden");
			imageSrc = ServerErrorImg;
			break;
	}

	return (
		<Box
			sx={{
				padding: 2,
				height: "100vh",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flexDirection: "column",
			}}
		>
			<Box alt="Error image" component="img" mb={3} src={imageSrc} />

			<div className="text-md font-bold text-center mb-2">{title}</div>

			<div className="text-smd text-text-meta text-center mb-8">{ts("description")}</div>

			<div className="w-auto">
				<Button title={ts("buttonText")} onClick={() => navigate("/")} />
			</div>
		</Box>
	);
};
